module.exports = __webpack_public_path__ + "static/media/(V)_MG_6102_-_capim_dourado_-_bijuterias.d9306852.jpg";